<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <div class="dateboard">
      <div class="wrap">
        <div class="item">
          <div class="label">上月维修费：</div>
          <div class="value">{{ num1 || 0 }}</div>
        </div>
        <div class="item item01">
          <div class="label">本月维修费：</div>
          <div class="value">{{ num2 || 0 }}</div>
        </div>
        <div class="item item02">
          <div class="label">待结维修费：</div>
          <div class="value">{{ num3 || 0 }}</div>
        </div>
        <div class="item item04">
          <div class="label">累计维修费：</div>
          <div class="value">{{ num4 || 0 }}</div>
        </div>
      </div>
    </div>

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item v-if="!hideAddBtn" class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" :btns="btns" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />

    <FormDialog ref="dialog" :title="title" :width="'560px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onChange="onModalChange" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  computed: {
    hideAddBtn() {
      return ![1, 2, 3, 4].includes(this.user.user_group_id)
    },
  },
  data() {
    return {
      baseUrl: 'reunitpayment',
      // getListUrl: 'index',
      breadcrumb: [
        { name: "维保管理", path: `/fix/repairer` },
        { name: "维修商管理", path: `/fix/repairer` },
        { name: "打款记录" },
      ],
      num1: 0,
      num2: 0,
      num3: 0,
      num4: 0,
      formCtrl: [
        {
          ...this.ctrls.month,
          label: "打款日期：",
          keyName: "pay_at",
        },
      ],
      cols: [
        { keyName: "maunit", label: "维修商名称" },
        { keyName: "money", label: "打款金额", minwidth: 300 },
        { keyName: "pay_at", label: "打款日期" },
        { keyName: "desc", label: "备注", minwidth: 120 },
      ],
      getTotalProperty: ["money"],
      btns: [
        {
          ...this.viewBtn,
          title: "查看",
          cb: ({ maunit, money, pay_at, images, desc }) => {
            // console.log(id)
            this.title = '查看打款记录'
            this.viewMode = true
            this.mform = { name: maunit, money, pay_at, images, desc }
            // console.log({ ...this.mform })
            this.showDialog()
          },
        },
      ],
      title: '查看打款记录',
      mform: {},
      mrules: {
        money: [
          {
            required: true,
            message: '请填写打款金额',
            trigger: 'blur',
          }
        ],
        pay_at: [
          {
            required: true,
            message: '请选择打款日期',
            trigger: 'blur',
          }
        ],
        images: [
          {
            required: true,
            message: '请上传打款凭证',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "维修商名称",
          keyName: "name",
          type: "text",
          disabled: true,
        },
        {
          label: "打款金额",
          keyName: "money",
          err: "请填写打款金额",
          type: "number",
        },
        {
          label: "打款日期",
          keyName: "pay_at",
          err: "请选择打款日期",
          type: "date",
        },
        {
          label: "打款凭证",
          keyName: "images",
          tips: "最多上传10张图片",
          type: "file",
          ptype: "payment",
          max: 10,
        },
        {
          label: "备注",
          keyName: "desc",
          err: "请填写备注信息",
          type: "textarea",
          rows: 3,
        },
      ],
      viewMode: false,
      baseParams: ['r_id'],
    };
  },
  methods: {
    addItem() {
      this.title = '添加打款记录'
      this.viewMode = false
      const { name, r_id } = this.mform
      this.mform = {
        name,
        r_id,
        money: '',
        pay_at: '',
        images: null,
        desc: '',
      }
      console.log({ ...this.mform })
      this.showDialog()
    },
    onModalSubmit() {
      // console.log({ ...data })
      console.log({ ...this.mform })
      if (this.loading) return
      this.loading = true
      let url = `${this.baseUrl}/${this.modalSubmitUrl}`;
      const params = {
        userid: this.user.id,
      }
      // 基础参数打包
      this.paramsPackage(params, this.mform)
      // 特殊参数打包处理
      this.specialParamsPackage(params)
      // console.log(url, params)
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hideDialog()
          this.getList()
          const { id, add_id } = this.$route.query
          this.getOptions({
            r_id: id,
            add_id,
          })
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        this.loading = false
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    tableDataHandler(res) {
      if (typeof res === 'string') {
        this.$message({
          type: 'error',
          message: res
        });
      } else {
        const { count, data } = res
        this.total = count
        if (data && data.length) {
          // console.log(data)
          // this.tableData = [...data]
          this.tableData = data.map(v => {
            return this.dataObjHandler(v)
          })
          this.setListHistory()
        }
      }
    },
    setOptions({ data: {
      pending_repair_cost,
      total_repair_cost,
      last_month_repair_cost,
      current_month_repair_cost,
    } }) {
      this.num1 = last_month_repair_cost
      this.num2 = current_month_repair_cost
      this.num3 = pending_repair_cost
      this.num4 = total_repair_cost
    },
  },
  mounted() {
    const { user_group_id, nickname } = this.user
    if (user_group_id == 13) {
      this.breadcrumb = [
        { name: "财务管理" }
      ]
      const { id } = this.user
      this.getOptions({ userid: id })
      this.mform.name = nickname
      this.mform.r_id = id
      this.formInline['userid'] = id
      this.$nextTick(this.getList);
    } else {
      if ([1, 2, 3, 4].includes(user_group_id)) {
        this.btns.push({
          ...this.editBtn,
          title: "编辑",
          cb: ({ maunit, money, pay_at, images, desc, id }) => {
            // console.log(id)
            this.title = '编辑打款记录'
            this.viewMode = false
            this.mform = { name: maunit, money, pay_at, images, desc, id }
            // console.log({ ...this.mform })
            this.showDialog()
          },
        })
      }
      const { id, name, add_id } = this.$route.query
      this.getOptions({
        r_id: id,
        add_id,
      })
      this.mform.name = name
      this.mform.r_id = id
      this.$forceUpdate()
      // console.log({ ...this.mform })
      this.formInline['r_id'] = id
      this.$nextTick(this.getList);
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog {
  .el-form {
    .el-form-item {

      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 100% !important;
      }
    }
  }

  .btns {
    .mians {
      text-align: center;
    }
  }
}

.main {
  /deep/ .fillet {
    box-shadow: none;
    border-radius: 0;
  }
}

.dateboard {
  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.04);
  border-radius: 3px;
  background: #fff;
  // border-radius: 5px 5px 0 0;
  overflow: hidden;

  .wrap {
    display: flex;
    align-items: center;
    padding: 20px;
    margin: 20px;
    background: #F7F7F7;
  }

  .item {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #606266;

    &:not(:first-of-type) {
      margin-left: 100px;
    }

    .label {
      position: relative;
      padding-left: 36px;
      height: 25px;
      line-height: 25px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        background: #FFFFFF url(../../../assets/img/ico_payment_01.png) no-repeat center center;
        background-size: 11px;
      }

    }

    &.item01 {
      .label {

        &::before {
          background-image: url(../../../assets/img/ico_payment_02.png);
        }
      }
    }

    .value {
      height: 25px;
      line-height: 25px;
    }
  }
}
</style>
